import React from 'react';
import { connect } from 'react-redux';
import { ToastProvider } from '../components/ui';
import withToast from './setup/withToast';
import UnifiedSetupPane from './setup/UnifiedSetupPane';
import { CompaniesPane, LpnsPane, PeoplePane } from './setup/CataloguePane';
import DisplaySettings from './DisplaySettings';
import './setup/setup.css';

/*
 * AdminScreen — the Setup workspace router (Console reskin, master-detail).
 *
 * Replaces the old "separate white modal per entity" pattern. Reads the SAME
 * Redux field the app already uses to choose the screen
 * (state.admin.showAdminControl) and mounts the matching master-detail pane.
 * Every pane preserves its entity's CRUD verbatim (Redux list thunks + the exact
 * fetch URLs/bodies from the original XControl/XForm pairs) — only presentation
 * changed. See each pane for the action/endpoint mapping.
 *
 * showAdminControl values → pane:
 *   'customer' | 'gate' | 'site' | 'user' | 'assignment' → UnifiedSetupPane
 *       (the single "places tree + context tabs" workspace that merges the old
 *        Organization + Users & Guards + Gate Assignments screens)
 *   'company'     → CompaniesPane
 *   'lpn'         → LpnsPane
 *   'person'      → PeoplePane
 *   'display'     → DisplaySettings (theme toggle only)
 *
 * A single <ToastProvider> wraps the whole workspace so panes can surface
 * success/error via the design-system toast (bridged to a `toast` prop by
 * withToast, since the panes are connected class components).
 */

// toast-injected pane variants (memoized module-level so identity is stable)
const UnifiedSetupPaneT = withToast(UnifiedSetupPane);
const CompaniesPaneT = withToast(CompaniesPane);
const LpnsPaneT = withToast(LpnsPane);
const PeoplePaneT = withToast(PeoplePane);

function renderPane(control) {
  switch (control) {
    // All provisioning (subscribers/customers/sites/gates, users & guards, assignments) now lives
    // in the ONE unified pane — the control value no longer picks a screen, only the entry point.
    case 'gate':
    case 'customer':
    case 'site':
    case 'user':
    case 'assignment':
      return <UnifiedSetupPaneT />;
    case 'company':
      return <CompaniesPaneT />;
    case 'lpn':
      return <LpnsPaneT />;
    case 'person':
      return <PeoplePaneT />;
    case 'display':
      return <DisplaySettings />;
    default:
      return null;
  }
}

const AdminScreen = ({ showAdminControl }) => (
  <div className="adminScreen">
    <ToastProvider>
      {renderPane(showAdminControl)}
    </ToastProvider>
  </div>
);

const mapStateToProps = (state) => ({
  showAdminControl: state.admin.showAdminControl,
});

export default connect(mapStateToProps)(AdminScreen);
